export const CustomEntityType = {
  VIEW: 'view',
  TABLE: 'table',
}
